import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function SignOut() {
  const { currentUser, logout } = useAuth();
  const [change, setChange] = useState(false);
  useEffect(() => {
    logout();
    // setTimeout(() => {
    //   setChange(true);
    //   window.location.reload();
    // }, 2000);
  }, [currentUser]);
  if (change || !currentUser) return <Redirect to="/" />;
  else return <h1 id="signing-out"></h1>;
}

export default SignOut;
